import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import ReturnsSidebar from '../../react-components/ReturnsSidebar/ReturnsSidebar';
import ItemInfo from '../../react-components/SidebarItemDetails/SidebarItemDetails';
import s from './exchangeSidebar.module.css';
import InventoryUnavailableMenu from './components/InventoryUnavailableMenu';
import ExchangeMenu from './components/ExchangeMenu';
import { store } from '../../store';
import ProductOptionsMenu from '../../react-components/ProductOptionsMenu';
import { ActionTypes } from '../../constants/enums';
import UnevenExchanges from './components/UnevenExchanges';

export const renderExchangeSidebar = ({ sidebarState, actions, handlers, node }) => {
  const {
    claims: { enabled: claimsEnabled } = {},
    language,
    page: { productType },
    restrictions: { maxItemsReached },
    returnsSettings: {
      [productType]: {
        exchange: { unevenExchanges } = {},
        product_options: productOptions = [],
        sidebar_item_attrs: itemAttributes,
        sidebar_comments: {
          [productType]: {
            comments_count: maxCommentLength = 300,
            comments_count_disabled: isCommentBoxCountDisabled = false,
          } = {},
        } = {},
      } = {},
    },
  } = store.getState();
  const {
    currentItem,
    returnEligibility,
    outOfStockError,
    itemQuantity,
    savedItems,
    exchangeComment,
    selectedProduct,
    open,
    commentHidden,
    commentRequired,
    commentPlaceholder,
    options,
    exchangeSelectionRequired,
    itemQtyOptions,
    selectedOptions,
    exchangeOptions,
    inventoryError,
    inventoryUnavailable,
    returnQuantity,
    selectedExchangeItem,
    loading,
    exchangeReasons,
    nestedReasons,
    selectedReason,
    selectedNestedReason,
    nestedReasonsTitle,
    photoUploadEnabled,
    photoUploadRequired,
    photoUploadPlaceholder,
    photoUploadTitle,
    photoUploadMaxFiles,
  } = sidebarState;

  const {
    checkSelected,
    handleOptionChange,
    getOnFocusOptions,
    checkReasonIsSelected,
    handleSelectReason,
    resetReasons,
    handleUnevenExchangeSubmit,
  } = handlers;

  const itemSaved = currentItem && savedItems[currentItem.item_id];
  const currentItemId = currentItem && currentItem.item_id;
  const isUnevenExchangeFlow = unevenExchanges && selectedProduct;

  render(
    <Provider store={store}>
      <div role="dialog" aria-label="Exchange Sidebar">
        <ReturnsSidebar
          title={language['returns.step_1.sidepanel_title']}
          toggleSide="right"
          sidebarOpen={open}
          closeIconOnClick={actions.toggle}
          overlayOnClick={actions.toggle}
          disableClose={maxItemsReached}
          loading={loading}
        >
          {!isUnevenExchangeFlow && (
            <div className={s.panel_content} aria-label="Side Panel Content">
              <ItemInfo
                item={selectedExchangeItem[currentItemId] || currentItem || {}}
                displayImg
                itemProperties={itemAttributes || ['Color', 'Size']}
                language={language}
              />
            </div>
          )}

          {!inventoryUnavailable ? (
            <div>
              {selectedProduct &&
                (unevenExchanges ? (
                  <UnevenExchanges
                    toggleSidebar={actions.toggle}
                    currentItem={currentItem}
                    returnEligibility={returnEligibility}
                    productSelectMenu={productOptions.map((product) => ({
                      type: product,
                      displayName: language[`returns.step_1.sidepanel_product.${product}`],
                    }))}
                    productSelectOnClick={actions.resetProductSelection}
                    checkSelected={checkSelected}
                    itemSaved={itemSaved}
                    outOfStockError={outOfStockError}
                    exchangeOptions={exchangeOptions}
                    language={language}
                    itemQuantity={itemQuantity}
                    quantitySelectOnChange={actions.handleQtySelect}
                    returnQuantity={returnQuantity}
                    isCommentBoxCountDisabled={isCommentBoxCountDisabled}
                    exchangeComment={exchangeComment}
                    maxCommentLength={maxCommentLength}
                    commentPlaceholder={commentPlaceholder}
                    commentHidden={commentHidden}
                    commentRequired={commentRequired}
                    exchangeCommentOnChange={actions.handleCommentInput}
                    exchangeReasons={exchangeReasons}
                    nestedReasons={nestedReasons}
                    selectedReason={selectedReason}
                    selectedNestedReason={selectedNestedReason}
                    checkReasonIsSelected={checkReasonIsSelected}
                    handleSelectReason={handleSelectReason}
                    resetReasons={resetReasons}
                    nestedReasonsTitle={nestedReasonsTitle}
                    photoUploadRequired={photoUploadRequired}
                    photoUploadEnabled={photoUploadEnabled}
                    photoUploadTitle={photoUploadTitle}
                    photoUploadPlaceholder={photoUploadPlaceholder}
                    photoUploadMaxFiles={photoUploadMaxFiles}
                    onSubmit={handleUnevenExchangeSubmit}
                    onCancel={actions.deleteItem}
                  />
                ) : (
                  <ExchangeMenu
                    returnEligibility={returnEligibility}
                    productSelectMenu={
                      claimsEnabled
                        ? [...productOptions, ActionTypes.Claim].map((product) => ({
                            type: product,
                            displayName:
                              language[`returns.step_1.item_sidepanel_product.${product}`],
                          }))
                        : productOptions.map((product) => ({
                            type: product,
                            displayName: language[`returns.step_1.sidepanel_product.${product}`],
                          }))
                    }
                    productSelectOnClick={actions.resetProductSelection}
                    checkSelected={checkSelected}
                    itemSaved={itemSaved}
                    outOfStockError={outOfStockError}
                    options={options}
                    exchangeOptions={exchangeOptions}
                    language={language}
                    exchangeOptionSelectOnChange={handleOptionChange}
                    exchangeOptionSelectOnFocus={getOnFocusOptions}
                    exchangeSelectedOptions={selectedOptions}
                    itemQuantity={itemQuantity}
                    itemQtyOptions={itemQtyOptions}
                    exchangeSelectionRequired={exchangeSelectionRequired}
                    quantitySelectOnChange={actions.handleQtySelect}
                    quantitySelectOnFocus={getOnFocusOptions('quantity')}
                    returnQuantity={returnQuantity}
                    isCommentBoxCountDisabled={isCommentBoxCountDisabled}
                    exchangeComment={exchangeComment}
                    maxCommentLength={maxCommentLength}
                    commentPlaceholder={commentPlaceholder}
                    commentHidden={commentHidden}
                    commentRequired={commentRequired}
                    exchangeCommentOnChange={actions.handleCommentInput}
                    submitOnClick={() => actions.saveItem()}
                    cancelOnClick={actions.deleteItem}
                    exchangeReasons={exchangeReasons}
                    nestedReasons={nestedReasons}
                    selectedReason={selectedReason}
                    selectedNestedReason={selectedNestedReason}
                    checkReasonIsSelected={checkReasonIsSelected}
                    handleSelectReason={handleSelectReason}
                    resetReasons={resetReasons}
                    nestedReasonsTitle={nestedReasonsTitle}
                    photoUploadEnabled={photoUploadEnabled}
                    photoUploadRequired={photoUploadRequired}
                    photoUploadTitle={photoUploadTitle}
                    photoUploadPlaceholder={photoUploadPlaceholder}
                    photoUploadMaxFiles={photoUploadMaxFiles}
                  />
                ))}
              {!selectedProduct &&
                (returnEligibility ? (
                  <ProductOptionsMenu
                    options={productOptions.map((product) => ({
                      type: product,
                      displayName: language[`returns.step_1.sidepanel_product.${product}`],
                    }))}
                    inventoryError={inventoryError}
                    onClick={actions.handleSelectProduct}
                    checkSelected={checkSelected}
                  />
                ) : (
                  <div>{language['returns.step_1.exchange_eligibility_only_header']}</div>
                ))}
            </div>
          ) : (
            <InventoryUnavailableMenu
              returnEligibility={returnEligibility}
              onClickDelete={actions.deleteItem}
              onClickSwitchToReturn={() => actions.handleSelectProduct(0, { type: 'return' })}
            />
          )}
        </ReturnsSidebar>
      </div>
    </Provider>,
    node,
  );
};
